import { render, staticRenderFns } from "./report.vue?vue&type=template&id=1bfcf0a1&scoped=true"
import script from "./report.vue?vue&type=script&lang=ts"
export * from "./report.vue?vue&type=script&lang=ts"
import style0 from "./report.vue?vue&type=style&index=0&id=1bfcf0a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfcf0a1",
  null
  
)

export default component.exports